import { addNotificationToApp, NotificationType } from './NotificationsActions';
import { ReduxDispatch } from '../types/redux/ReduxDispatch';
import { EnrollmentPackageId } from '../types/api/primaryKeys/PrimaryKey';
import * as Api from '../apiCalls/cart/cartApiCalls';
import { PackageCart } from '../types/api/cart/PackageCart';

export enum CartActionType {
    FETCH_CART = "FETCH_CART",
    FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS",
    TOGGLE_CART = "TOGGLE_CART"
}

export type CartAction = 
    | ReturnType<typeof requestFetchCart>
    | ReturnType<typeof requestFetchCartSuccess>
    | ReturnType<typeof toggleCart>


function requestFetchCart() {
    return {
        type: CartActionType.FETCH_CART
    } as const;
}

function requestFetchCartSuccess(cart: PackageCart) {
    return {
        type: CartActionType.FETCH_CART_SUCCESS,
        payload: cart
    } as const;
}

export function fetchCartInfo(packageId: EnrollmentPackageId) {
    return async (dispatch: ReduxDispatch) => {
        dispatch(requestFetchCart());

        try {
            const json = await Api.getCartSummary(packageId);
            dispatch(requestFetchCartSuccess(json));
        }
        catch (err) {
            dispatch(addNotificationToApp("Failed To Get Cart Details", NotificationType.Error));
        }
    };
}

export function toggleCart() {
    return {
        type: CartActionType.TOGGLE_CART
    } as const;
}